import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EDayType } from 'projects/shared/lib/enum/time/day-type.enum';

@Component({
    selector: 'app-calendar-day-base',
    template: '',
    standalone: false
})
export class CalendarDayBaseComponent {
  @Input() public day?: Date | undefined;
  @Input() public isDisabled?: boolean | undefined;
  @Input() public isSelected?: boolean | undefined;
  @Input() public dayType?: EDayType | undefined;

  @Output() public onClicked: EventEmitter<Date | undefined>;

  public eDayType: typeof EDayType;

  public constructor() {
    this.eDayType = EDayType;
    this.dayType = EDayType.Default;
    this.onClicked = new EventEmitter<Date | undefined>();
  }

  public onClick() {
    if (this.isDisabled) {
      return;
    }

    this.onClicked.emit(this.day);
  }

}
